// Tag for graphql format
const gql = String.raw;

// Fragments
import {
	CallActivityPerformanceFragment,
	LongevityFragment,
	TopPerformerBonusFragment,
	UserFullNameFragment,
	InputValueFragment,
	ModelYearsFragment,
	CommissionTiersFragment,
	MetricFragment,
	VolumeBonusFragment,
	BonusDefinitionFragment,
	VariableOperationsGpsBonusSetupFragment,
} from "@PayPlans/api/fragments/commons";

import {
	DefaultCommissionsFragment,
	MiniDealFragment,
	ModelBasedFragment,
	DemoAllowanceFragment,
	PacksFragment,
	AutoAlertsFragment,
	CustomerSatisfactionFragment,
	DefaultCommissionsTierFragment,
	AdjustmentTierFragment,
} from "@PayPlans/api/fragments/salesAssociates";

export const onCreateSalesPayPlan = gql`
	subscription onCreateSalesPayPlan($locationId: String) {
		onCreateSalesPayPlan(locationId: $locationId) {
			_id
			locationId
			name
			position
			default {
				...DefaultCommissions
			}
			miniDeal {
				...MiniDeal
			}
			modelBased {
				...ModelBased
			}
			callActivityPerformance {
				...CallActivityPerformance
			}
			volumeBonus {
				...VolumeBonus
			}
			demoAllowance {
				...DemoAllowance
			}
			packs {
				...Packs
			}
			autoAlerts {
				...AutoAlerts
			}
			topSalesBonus {
				...TopPerformerBonus
			}
			customerSatisfaction {
				...CustomerSatisfaction
			}
			variableOperationsGpsBonus {
				...VariableOperationsGpsBonusSetup
			}
			longevity {
				...Longevity
			}
			locked
			formatVersion
			createdAt
			createdBy {
				...UserFullName
			}
			updatedAt
			updatedBy {
				...UserFullName
			}
		}
	}
	${DefaultCommissionsFragment}
	${MiniDealFragment}
	${ModelBasedFragment}
	${CallActivityPerformanceFragment}
	${VolumeBonusFragment}
	${BonusDefinitionFragment}
	${DemoAllowanceFragment}
	${PacksFragment}
	${AutoAlertsFragment}
	${TopPerformerBonusFragment}
	${CustomerSatisfactionFragment}
	${LongevityFragment}
	${UserFullNameFragment}
	${InputValueFragment}
	${DefaultCommissionsTierFragment}
	${ModelYearsFragment}
	${AdjustmentTierFragment}
	${CommissionTiersFragment}
	${MetricFragment}
	${VariableOperationsGpsBonusSetupFragment}
`;

export const onCloneSalesPayPlan = gql`
	subscription onCloneSalesPayPlan($locationId: String) {
		onCloneSalesPayPlan(locationId: $locationId) {
			_id
			locationId
			name
			position
		}
	}
`;

export const onUpdateSalesAvailablePayPlan = gql`
	subscription onUpdateSalesAvailablePayPlan($locationId: String, $_id: String) {
		onUpdateSalesAvailablePayPlan(locationId: $locationId, _id: $_id) {
			_id
			available
			name
			position
		}
	}
`;

export const onDeleteSalesPayPlan = gql`
	subscription onDeleteSalesPayPlan($locationId: String) {
		onDeleteSalesPayPlan(locationId: $locationId) {
			_id
			locationId
		}
	}
`;

export const onUpdateSalesPayPlan = gql`
	subscription onUpdateSalesPayPlan($locationId: String, $_id: String) {
		onUpdateSalesPayPlan(locationId: $locationId, _id: $_id) {
			_id
			locationId
			name
			position
			default {
				...DefaultCommissions
			}
			miniDeal {
				...MiniDeal
			}
			modelBased {
				...ModelBased
			}
			callActivityPerformance {
				...CallActivityPerformance
			}
			variableOperationsGpsBonus {
				...VariableOperationsGpsBonusSetup
			}
			volumeBonus {
				...VolumeBonus
			}
			demoAllowance {
				...DemoAllowance
			}
			packs {
				...Packs
			}
			autoAlerts {
				...AutoAlerts
			}
			topSalesBonus {
				...TopPerformerBonus
			}
			customerSatisfaction {
				...CustomerSatisfaction
			}
			longevity {
				...Longevity
			}
			locked
			formatVersion
			createdAt
			createdBy {
				...UserFullName
			}
			updatedAt
			updatedBy {
				...UserFullName
			}
		}
	}
	${DefaultCommissionsFragment}
	${MiniDealFragment}
	${ModelBasedFragment}
	${CallActivityPerformanceFragment}
	${VolumeBonusFragment}
	${BonusDefinitionFragment}
	${DemoAllowanceFragment}
	${PacksFragment}
	${AutoAlertsFragment}
	${TopPerformerBonusFragment}
	${CustomerSatisfactionFragment}
	${LongevityFragment}
	${UserFullNameFragment}
	${InputValueFragment}
	${DefaultCommissionsTierFragment}
	${ModelYearsFragment}
	${AdjustmentTierFragment}
	${CommissionTiersFragment}
	${MetricFragment}
	${VariableOperationsGpsBonusSetupFragment}
`;

export const onUpdateAnySalesPayPlan = gql`
	subscription onUpdateAnySalesPayPlan($locationId: String) {
		onUpdateAnySalesPayPlan(locationId: $locationId) {
			locationId
		}
	}
`;
